import { render, staticRenderFns } from "./ModalRegulacao.vue?vue&type=template&id=f8bfca02&scoped=true"
import script from "./ModalRegulacao.vue?vue&type=script&lang=ts"
export * from "./ModalRegulacao.vue?vue&type=script&lang=ts"
import style0 from "./ModalRegulacao.vue?vue&type=style&index=0&id=f8bfca02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bfca02",
  null
  
)

export default component.exports